import { Item, Wemi, Work } from '@skinsoft/types'
import { itemSelectors, wemiSelectors, workSelectors } from '@skinsoft/selectors'
import { dbCacheDown } from '../dexie/cache-down'
import { STATS_KEYS } from '../dexie/stats-keys'
import { OfflineDataFetcher } from '@skinsoft/offline'
import { matchesRegex } from '@skinsoft/utils'

export type WemiOfflineDataFetcher = ItemOfflineDataFetcher;

// @ts-ignore
export class ItemOfflineDataFetcher extends OfflineDataFetcher<Item> {

    constructor() {
        super(dbCacheDown.item, STATS_KEYS.item)
    }

    /*public fetchWemiFromId(id: string): Observable<Wemi> {
        return WemiUtils.getWemiFromItem(id);
    }*/

    protected idMatcher(entity: any, id: string) {
        if (entity.item) {
            return entity.item.id === id;
        }
        return false;
    }

    protected async queryTextFilter(entity: Wemi | Item, queryText: string, locale: string): Promise<boolean> {
        const lowerCaseQueryText: string = queryText.toLowerCase()

        const isWemi: boolean = "item" in entity && "manifestation" in entity && "expression" in entity && "work" in entity

        let titleMatch: boolean
        let identifierMatch: boolean
        let workTitleMatch: boolean = false
        if(isWemi) {
            // item title match 
            const title: string = wemiSelectors.title(entity as Wemi, locale);
            try{
                titleMatch = title ? matchesRegex(lowerCaseQueryText, title.toLowerCase()) : false
            } catch(err) {
                titleMatch = false
            }

            // item identifier match
            const identifier: string = wemiSelectors.inventoryNumber(entity as Wemi, locale);
            try {
                identifierMatch = identifier ? matchesRegex(lowerCaseQueryText, identifier.toLowerCase()) : false
            } catch(err) {
                identifierMatch = false
            }

        } else {
            // item title match 
            const title: string | undefined = itemSelectors.title(entity as Item, locale);
            try {
                titleMatch = title ? matchesRegex(lowerCaseQueryText, title.toLowerCase()) : false;
            } catch(err) {
                titleMatch = false
            }

            const workTitle: string | null = workSelectors.workTitle(entity as Work, locale)
            if(workTitle !== null) {
                try {
                    workTitleMatch = matchesRegex(lowerCaseQueryText, workTitle.toLowerCase())
                } catch(err) {
                    // worktitle already equals false
                }
            }

            // item identifier match
            const identifier: string = itemSelectors.inventoryNumber(entity as Item)?.value ?? itemSelectors.inventoryNumber(entity as Item)
            try {
                identifierMatch = identifier ? matchesRegex(lowerCaseQueryText, identifier.toLowerCase()) : false;
            } catch(err) {
                identifierMatch = false
            }
        }

        return titleMatch || identifierMatch || workTitleMatch
    }
}